import React from 'react';
import { Link } from 'react-router-dom';
import Sock_box from './assets/freud_sock.jpg'; 
import neymar_sock from './assets/Neymar.jpg'
import persons from './assets/persons.jpg'
import men from './assets/men.jpeg'
import girll from './assets/girll.jpg'
import girl from './assets/girl.jpg'
import girlll from './assets/girlll.jpg'
import box1 from './assets/IMG_7937.jpeg'
import box2 from './assets/IMG_7939.jpeg'
import box3 from './assets/3socks.jpg'
import CategorySlideShow from './CategorySlideShow';
import NewsletterSection from './NewsletterSection'; 

const Home = ({ handleTypeChange }) => {
  const sock_links = {
    menImages: [
      neymar_sock,
      persons,
      men,
      'https://res.cloudinary.com/dgl3cjrcu/image/upload/v1742301816/IMG_7934_d983rc.jpg',
      'https://res.cloudinary.com/dgl3cjrcu/image/upload/v1742302001/mennn_sfu12m.jpg'
    ],
    womenImages: [
      girl,
      girll,
      girlll,
      'https://res.cloudinary.com/dgl3cjrcu/image/upload/v1742299548/scoobydoo_dp4kib.jpg',
      'https://res.cloudinary.com/dgl3cjrcu/image/upload/v1742300598/IMG_7933_wvhznf.jpg'
    ],
    boxImages:[
      box1,
      box2,
      box3,
      'https://res.cloudinary.com/dgl3cjrcu/image/upload/v1742301488/starwar_box_ap5sti.jpg',
      'https://res.cloudinary.com/dgl3cjrcu/image/upload/v1742301755/boxx_whwzyh.jpg'
    ]
  }
  return (
    <div className="bg-[#F5F5F5] font-serif mt-28 md:mt-0">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center text-white">
        <img
          src={Sock_box}
          alt="Cotton Kosovo Socks"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Cotton Kosovo Socks</h1>
          <p className="text-xl md:text-2xl mb-8">Comfortable, Stylish, and Perfect for Every Occasion</p>
          <Link
            to="/products"
            className="bg-[#1A2A3A] text-white px-8 py-3 rounded-lg text-lg hover:bg-indigo-600 transition duration-300"
          >
            <button onClick={()=>handleTypeChange('')}>Shop Now</button>
          </Link>
        </div>
      </section>

      {/* Featured Products Section */}
      <section className="py-16 px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A2A3A] mb-8">Featured Products</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {/* Men's Socks */}
          <CategorySlideShow
            images={sock_links.menImages}
            title="Men's Striped Socks"
            price="2"
            type="men"
            handleTypeChange={handleTypeChange} // Pass the function as a prop
          />

          {/* Women's Socks */}
          <CategorySlideShow
            images={sock_links.womenImages}
            title="Women's Ankle Socks"
            price="2"
            type="women"
            handleTypeChange={handleTypeChange} // Pass the function as a prop
          />

          {/* Box of Socks */}
          <CategorySlideShow
            images={sock_links.boxImages}
            title="Box of Socks"
            price="10"
            type="box"
            handleTypeChange={handleTypeChange} // Pass the function as a prop
          />
        </div>
      </section>

      {/* About Us Section */}
      <section className="bg-[#1A2A3A] text-white py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">About Us</h2>
          <p className="text-lg md:text-xl mb-8">
            At Cotton Kosovo Socks, we believe that socks are more than just an accessory. They are an essential part of your wardrobe that can add a touch of personality and comfort to your everyday life. Our mission is to provide you with socks that not only look great but also feel great, ensuring your feet are well taken care of.
          </p>
          <Link
            to="/about"
            className="bg-white text-[#1A2A3A] px-8 py-3 rounded-lg text-lg hover:bg-gray-200 transition duration-300"
          >
            Learn More
          </Link>
        </div>
      </section>
      
      <NewsletterSection/>

    </div>
  );
};

export default Home;